import { HTMLAttributes, useMemo, useState } from 'react';
import styles from './FormUtils.module.scss';
import { cn } from '../../../utils/utils';
import Button, { ButtonProps } from '../Button/Button';
import Confirm from '../Confirm/Confirm';
import { Control, Controller } from 'react-hook-form';
import { GENERAL_STATUS } from '../../../constants/constants';
import SelectComponent from '../Select/Select';

export const FormActions: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...otherProps
}) => {
  return <div className={styles['actions']} {...otherProps} />;
};

export const InputsRow: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...otherProps
}) => {
  return <div className={cn(styles['input-row'], 'row', className)} {...otherProps} />;
};

type CancelButtonProps = Partial<ButtonProps> & { showAlert: boolean; onCancel: () => void };

export const CancelButton: React.FC<CancelButtonProps> = ({
  showAlert,
  onCancel,
  ...otherProps
}) => {
  const [cancelConfirm, setCancelConfirm] = useState(false);

  return (
    <>
      <Button
        text="Cancel"
        color="secondary-black"
        border
        disabled={false}
        action={() => (showAlert ? setCancelConfirm(true) : onCancel())}
        type="button"
        {...otherProps}
      />
      <Confirm
        open={cancelConfirm}
        title="Cancel?"
        description="Are you sure you want to cancel ? Unsaved changes will be lost."
        confirmText="Yes, Cancel"
        cancelText="No, Continue"
        onConfirm={onCancel}
        onCancel={() => setCancelConfirm(false)}
      />
    </>
  );
};
